// extracted by mini-css-extract-plugin
module.exports = {"censusErrors":"CensusErrors_censusErrors__2WYw8","errorsTitle":"CensusErrors_errorsTitle__1srQ-","rowInfo":"CensusErrors_rowInfo__33iop","hasName":"CensusErrors_hasName__x7deT"};